// Mimic the functionality of a details, but allow for responsive always showing
if (!customElements.get("countdown-timer")) {
	customElements.define(
		"countdown-timer",
		class DetailsCustom extends HTMLElement {
			constructor() {
				super()
				const timer = this.querySelector("#countdown-timer")

				if (!timer) return

				this.container = this.closest(".countdown-timer")
				this.coundown_timer_interval

				this.daySpan = timer.querySelector(".d")
				this.dayContainer = timer.querySelector(".day")
				this.hourSpan = timer.querySelector(".h")
				this.hourContains = timer.querySelector(".hour")
				this.minSpan = timer.querySelector(".m")
				this.minContainer = timer.querySelector(".mins")
				this.secSpan = timer.querySelector(".s")
				this.secContains = timer.querySelector(".sec")

				this.initTimer(timer)
			}

			initTimer(timer) {
				//https://stackoverflow.com/questions/56569124/countdown-timer-in-vanilla-javascript-without-using-a-function

				const mins = 10
				const now = new Date().getTime()

				const deadline = timer.dataset.deadline //passed through from liquid

				//block deadline to extend timer
				const block_deadline = parseInt(timer.dataset.blockDeadline)
				const block_final_deadline = !isNaN(block_deadline) ? new Date(parseInt(block_deadline)).getTime() : false

				const final_deadline = new Date(parseInt(deadline)).getTime()

				var ms_to_deadline = final_deadline - now

				console.log(`Deadline = ${deadline} final_deadline = ${final_deadline} Now = ${now}  MS To Dead = ${ms_to_deadline}`)

				this.coundown_timer_interval = setInterval(() => {
					//Turn off timer as either deal is over or after
					if (ms_to_deadline >= 0 && final_deadline >= 0) {
						ms_to_deadline = this.incrementTimer(timer, ms_to_deadline)
					} else if (block_final_deadline && block_final_deadline >= new Date().getTime() && block_final_deadline > final_deadline) {
						//has a block deadline so use it as the thing
						const time_removed = now > final_deadline ? now : final_deadline
						var block_ms_to_deadline = block_final_deadline - time_removed
						ms_to_deadline = this.incrementTimer(timer, block_ms_to_deadline)
					} else {
						this.container.classList.add("hidden")
						window.clearInterval(this.coundown_timer_interval)
					}
				}, 1000)
			}

			incrementTimer(timer, ms_to_deadline) {
				var days = Math.floor(ms_to_deadline / (1000 * 60 * 60 * 24))
				var hours = Math.floor((ms_to_deadline % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
				var minutes = Math.floor((ms_to_deadline % (1000 * 60 * 60)) / (1000 * 60))
				var seconds = Math.floor((ms_to_deadline % (1000 * 60)) / 1000)

				if (days == 0) {
					this.dayContainer.classList.add("hidden")
				}

				this.daySpan.innerHTML = days
				this.hourSpan.innerHTML = hours
				this.minSpan.innerHTML = minutes
				this.secSpan.innerHTML = seconds

				timer.classList.add("in-view")

				var local_ms_to_deadline = ms_to_deadline - 1000

				return local_ms_to_deadline
			}
		}
	)
}
